// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PackMutationResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for pack create / update / setActive mutations.
 * Shape: { id: int, ok: bool }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PackMutationResponseDados {
id: number
ok: boolean
}

export type AiCredits_PackMutationResponse = ApiResponse<AiCredits_PackMutationResponseDados>;

registerResponseContract('AiCredits_PackMutationResponse', {
  id: { type: 'number',  required: true },
  ok: { type: 'boolean', required: true },
})
